import React, { useEffect } from "preact/compat";
import { useState } from 'preact/hooks';
import { ItemModifier, ItemModifierEntry } from "../typings/types";
import { getFromJson } from "../canvas/menu-object-renderer";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import MenuObject, { removeTrailingZeroes } from "../canvas/menu-object";
import store from "../store";
import * as actions from "../actions";

function getEmptyModifier() {
  return { name: '', entries: [{ name: '', price: '', displayPrice: '' }] };
}

export interface MenuContentModifiers {
  $element: JQuery,
  menuModifiers: string[] | ItemModifier[],
  onUpdate: (type: string, value: string, idx: number) => void,
  onRemove: (type: string, idx: number) => void,
  menuObjectLayout: string,
  hideTrailingZeroes: boolean,
}

export default function MenuContentModifiers({ $element, menuModifiers, onUpdate, onRemove, menuObjectLayout, hideTrailingZeroes }: MenuContentModifiers) {
  const [modifiers, setModifiers] = useState([] as ItemModifier[]);

  useEffect(() => {
    let mr = menuModifiers.map(m => typeof m === 'string' ? JSON.parse(m) : m);
    setModifiers([...mr]);
  }, [menuModifiers]);

  function setModifierAtIdx(newMod: ItemModifier, idx: number) {
    setModifiers([
      ...modifiers.slice(0, idx),
      newMod,
      ...modifiers.slice(idx + 1)
    ]);
  }

  function onChangeModifier(type: keyof ItemModifier, value: string, idx: number) {
    const newModifier = {
      ...modifiers[idx],
      [type as keyof ItemModifier]: value.replace(/"/g, "&dqt"),
    };

    setModifierAtIdx(newModifier, idx);
    onUpdate('modifiers', JSON.stringify(newModifier), idx);
  }

  function onChangeEntry(modifierIdx: number, type: keyof ItemModifierEntry, value: string, idx: number) {
    const thisMod = modifiers[modifierIdx];
    const newEntry = {
      ...thisMod.entries[idx],
      [type as keyof ItemModifierEntry]: value.replace(/"/g, "&dqt"),
      displayPrice: type === 'price' ?
        hideTrailingZeroes ? removeTrailingZeroes(value.replace(/"/g, "&dqt")) : value.replace(/"/g, "&dqt")
        : hideTrailingZeroes ? removeTrailingZeroes(thisMod.entries[idx].price) : thisMod.entries[idx].price
    }
    const newModifier = {
      name: thisMod.name,
      entries: [
        ...thisMod.entries.slice(0, idx),
        newEntry,
        ...thisMod.entries.slice(idx + 1)
      ]
    };

    setModifierAtIdx(newModifier, modifierIdx);
    onUpdate('modifiers', JSON.stringify(newModifier), modifierIdx);
  }

  function onRemoveEntry(modIdx: number, entryIdx: number) {
    const thisMod = modifiers[modIdx];
    thisMod.entries = thisMod.entries.filter((e, i) => entryIdx !== i);
    setModifierAtIdx(thisMod, modIdx);
    onUpdate('modifiers', JSON.stringify(thisMod), modIdx);
  }

  function onRemoveModifier(idx: number) {
    const newModifiers = modifiers.filter((v, i) => idx !== i);
    setModifiers(newModifiers);
    onRemove('modifiers', idx);
  }

  function onAddGroup() {
    MenuObject.updateShowModifiers($element, true);
    store.dispatch(actions.setShowModifiers(true));
    setModifiers([...modifiers, getEmptyModifier()]);
  }

  function onAddEntry(idx: number) {
    modifiers[idx].entries.push({name: '', price: '', displayPrice: ''});
    setModifiers([...modifiers]);
  }

  return (
    <div className={`modifiers ${$element.attr('data-show-modifiers') === 'true' ? '' : 'hidden'}`}>
      {modifiers.map((mod, modIdx) =>
        <div className={`modifier`}>
          <div className='mod-name'>
            <input placeholder={`Modifier Group ${modIdx + 1}`} className="field size"
              spellcheck
              autoComplete={'off'}
              value={mod.name.replace(/&dqt/g, '"')}
              onChange={e => onChangeModifier('name', (e.target as HTMLInputElement)?.value, modIdx)}
            />
            <button><DeleteOutlined onClick={() => onRemoveModifier(modIdx)} /></button>
          </div>

          {mod.entries.map((entry, entryIdx) => {
            return (<div className='modifier-entry'>
              <input
                placeholder={`Modifier ${entryIdx + 1}`}
                className="field mod-entry-name"
                spellcheck
                autoComplete={'off'}
                value={entry.name.replace(/&dqt/g, '"')}
                onChange={e => onChangeEntry(modIdx, 'name', (e.target as HTMLInputElement)?.value, entryIdx)}
              />

              <input
                placeholder={`Price ${entryIdx + 1}`}
                className="field mod-entry-price"
                spellcheck
                autoComplete="off"
                value={entry.price.replace(/&dqt/g, '"')}
                onChange={e => onChangeEntry(modIdx, 'price', (e.target as HTMLInputElement)?.value, entryIdx)}
              />

              <button><DeleteOutlined onClick={() => onRemoveEntry(modIdx, entryIdx)}/></button>
            </div>)
          })}

          <button className={'add-size'} onClick={() => onAddEntry(modIdx)}><span>+ Modifier</span></button>
        </div>
      )}
      <button className={'add-size mod-group'} onClick={onAddGroup}><span>+ Add Modifier Group</span></button>
    </div>
  )
}
